import React from 'react';
import PropTypes from 'prop-types';
import { DurationField } from 'lib';

const stringOrNumber = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);

const DurationInput = ({ value, title, ...props }) => (
  <DurationField
    value={{ hours: Number(value.hours) || 0, minutes: Number(value.minutes) || 0 }}
    labels={{ title }}
    {...props}
  />
);

DurationInput.propTypes = {
  value: PropTypes.shape({
    hours: stringOrNumber,
    minutes: stringOrNumber,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string,
  minHours: PropTypes.number,
  maxHours: PropTypes.number.isRequired,
  minuteStep: PropTypes.number,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  className: PropTypes.string,
};

DurationInput.defaultProps = {
  title: '',
};

export default DurationInput;
